import React, { useEffect } from 'react'
import { Tooltip } from 'react-tippy'
import 'react-tippy/dist/tippy.css'
import { TippyProps } from './tippy.types'

const exclusionList = ['broadcasts/edit', 'broadcasts/addAdvanced', 'addContentToDevice', 'displays', 'files']

const Tippy = (p_: TippyProps) => {
    const { children, html, title, ...props } = p_

    const clearTooltips = () => {
        const tooltips = document.querySelectorAll<HTMLElement>('.tippy-popper')
        tooltips.forEach((tooltip) => tooltip.remove())
    }

    useEffect(() => {
        const hash = window.location.hash

        if (!exclusionList.some((item) => hash.includes(item))) {
            clearTooltips()
        }
    }, [p_])

    if (!title && !html) {
        return <>{children}</>
    }

    const tooltipHtml =
        html === null || html === undefined ? undefined : React.isValidElement(html) ? html : <>{html}</>

    return (
        <Tooltip {...props} title={title} html={tooltipHtml} animateFill={false}>
            {children}
        </Tooltip>
    )
}

export default Tippy
